export default class CollabStatus {

  reInvite(element) {
    var collab_id = $(element).parent().data('collab-id');
    var name = $(element).closest('td').siblings('.td-company-name').text().trim() || 'この外部アカウント'
    var url = "/collaborators/re_invite"
    var data = { collab_id: collab_id }

    // [FIX 20260718] 承認待ちの招待メール送信も中央ダークモーダルに統一
    Popup.confirm(`${name}さんへ<br>招待メールを送信してよろしいですか？`, {
      confirmText: 'OK',
      success: () => {
        Shared.callAjax(url, data, 'json', 'post').done(function() {
          // [FIX 20260718] 完了メッセージはOK不要の自動トースト
          Popup.alert(`${name}さんへ<br>招待メールを送信しました。`, '', '', { timer: 2500, allowOutsideClick: false, allowEscapeKey: false })
          setTimeout(() => { location.reload() }, 2500)
        })
      },
      cancel: () => {}
    })
  }

  removeInvitation(element) {
    var collab_id = $(element).parent().data('collab-id');
    var name = $(element).closest('td').siblings('.td-company-name').text().trim() || 'この外部アカウント'
    var url = "/collaborators/remove_invitation"
    var data = { collab_id: collab_id }

    // [FIX 20260718] 承認待ちの招待解除も中央ダークモーダルに統一
    Popup.confirm(`${name}さんとの招待を解除すると<br>${name}のプロジェクト招待が全て解除され<br>${name}さんは閲覧が出来なくなります。<br>招待を解除してよろしいですか？`, {
      confirmText: 'OK',
      success: () => {
        Shared.callAjax(url, data, 'json', 'delete').done(function() {
          // [FIX 20260718] 完了メッセージはOK不要の自動トースト
          Popup.alert(`${name}さんの<br>招待を解除しました。`, '', '', { timer: 2500, allowOutsideClick: false, allowEscapeKey: false })
          setTimeout(() => { location.reload() }, 2500)
        })
      },
      cancel: () => {}
    })
  }

  quickApproveInvitation(element) {
    var collab_id = $(element).parent().data('collab-id');
    var url = "/collaborators/quick_approve_invitation"
    var data = { collab_id: collab_id }

    Shared.callAjax(url, data, 'json', 'post').done(function(data) {
      $("#modalBeInvited").find(".text-message").html("が外部メンバーになりました。")
      $("#modalBeInvited").find(".collab-name").html(data.collab_name)
      $("#modalBeInvited").modal({
        show: true,
        backdrop: 'static',
        keyboard: false
      })
    })
  }

  rejectInvitation(element) {
    var collab_id = $(element).parent().data('collab-id');
    var url = "/collaborators/reject_invitation"
    var data = { collab_id: collab_id }

    Shared.callAjax(url, data, 'json', 'post').done(function(data) {
      $("#modalBeInvited").find(".text-message").html("からの招待を解除しました。")
      $("#modalBeInvited").find(".collab-name").html(data.collab_name)
      $("#modalBeInvited").modal({
        show: true,
        backdrop: 'static',
        keyboard: false
      })
    })
  }
}
